import { Typography } from "@material-ui/core";
export function enoxaparinMonitoringText(renalImpairmentLevel, overWeightLimit, weightEdgeLimit) {
    let text = [];
    text.push([<Typography variant="body1" style={{ marginTop: 20 }}>
                    <strong>ENOXAPARIN MONITORING</strong>
                </Typography>]);

    if ((overWeightLimit && renalImpairmentLevel != 'severe') || (weightEdgeLimit && renalImpairmentLevel == 'minor') || (renalImpairmentLevel == 'moderate')) {
        text.push([<Typography variant="body2">
            <p>If treatment is to be continued beyond 48 hours: </p>
        </Typography>,
        <Typography variant="h6" color="primary">
            Measure PEAK anti-factor Xa level (4 hours post dose) after 3rd or 4th dose
            (to coincide with laboratory hours) and then measure every
            second day.
        </Typography>,]);
    } else if (renalImpairmentLevel == 'minor'){
        text.push([<Typography variant="body2">
            <p>If treatment is to be continued beyond 5 days: </p>
        </Typography>,
        <Typography variant="h6" color="primary">
            Measure PEAK anti-factor Xa level (4 hours post dose) on day 5
            (to coincide with laboratory hours) and then measure every
            second day.
        </Typography>,]);
    } else if (renalImpairmentLevel == 'severe'){
        text.push([<Typography variant="body2">
            <p>If enoxaparin is used, and treatment is to be continued beyond 48 hours: </p>
        </Typography>,
        <Typography variant="h6" color="primary">
            Measure TROUGH anti-factor Xa level (23 hours post dose) after 3rd dose 
            and then measure every second day.
        </Typography>,]);
    }  

    // Push Heparin warning
    if (weightEdgeLimit) {
        text.push([<Typography variant="body2">
        <p>Strongly consider IV heparin in extremes of body size, severe liver
             disease, diseases of skeletal muscle and elderly patients with low 
             body weight (as CrCl may be inaccurate).</p>
        <p>Use IV heparin if anti-factor Xa measurements are unavailable or
             renal function is unstable (e.g. acute kidney failure).</p>
    </Typography>])
    } else if (!overWeightLimit) {
        text.push([<Typography variant="body2">
        <p>Strongly consider IV heparin in extremes of body size, severe liver 
            disease, diseases of skeletal muscle (as CrCl may be inaccurate).</p>
        <p>Use IV heparin if anti-factor Xa measurements are unavailable or
             renal function is unstable (e.g. acute kidney failure).</p>
    </Typography>])
    };

    return text;
}